<app-header></app-header>
<app-nav-bar></app-nav-bar>
<app-title-bar></app-title-bar>
<router-outlet></router-outlet>
<app-footer-menu></app-footer-menu>

<button hidden="true" #acceptCookiesModalButton data-bs-toggle="modal" data-bs-target="#cookiesModal"></button>

<!-------------------------------------------  Cookies Modal  -------------------------------------------->
<div class="modal fade" id="cookiesModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <div class="modal-title text-primary fs-3">Cookie policy</div>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Chiudi" (click)="acceptCookies(true)"></button>
            </div>
            <div class="modal-body">
                <span class="text-primary">I cookie sono importanti per il corretto funzonamento di questo sito. Al fine di migliorare la tua esperienza, utilizziamo i cookie per memorizzare le informazioni di login, monitorare l'erogazione del servizio, fornirti un'esperienza coerente ai tuoi interessi.<!-- Per maggiori dettagli consulta la pagina <em><a href="privacy-policy" class="text-info">"privacy policy"</a></em>. --></span>
            </div>
            <div class="modal-footer justify-content-center">
                <div class="row">
                    <div class="col">
                        <button type="button" class="btn btn-secondary text-white" data-bs-dismiss="modal" (click)="acceptCookies(false)">RIFIUTO</button>
                    </div>
                    <div class="col">
                        <button type="button" class="btn btn-primary text-white" data-bs-dismiss="modal" (click)="acceptCookies(true)">ACCETTO</button>
                    </div>    
                </div>
            </div>
        </div>
    </div>
</div>
<!-------------------------------------------------------------------------------------------------------->